var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8",staticStyle:{"height":"600px"},attrs:{"id":"indicaciones"}}),_c('div',{staticClass:"col-md-4 table-responsive",staticStyle:{"height":"600px"},attrs:{"id":"panel"}},[_c('ol',{attrs:{"id":"route-steps"}})])])
}]

export { render, staticRenderFns }